import { z } from "zod";

export interface FilterOptions {
  deployments: string[];
  users: string[];
  manufacturers: string[];
  deviceModels: string[];
  maintenanceStatus: string[];
  deviceTags: string[];
  caseTags: string[];
  caseTypes: string[];
  maintenanceTags: string[];
}
export const defaultGlobalFilters: FilterOptions = {
  deployments: [] as string[],
  users: [] as string[],
  manufacturers: [] as string[],
  deviceModels: [] as string[],
  maintenanceStatus: [] as string[],
  deviceTags: [] as string[],
  caseTags: [] as string[],
  caseTypes: [] as string[],
  maintenanceTags: [] as string[],
};

export const globalFiltersSet = Object.keys(defaultGlobalFilters) as (keyof FilterOptions)[];

export const globalFiltersSearchSchema = z.object({
  deployments: z.array(z.string()).default([]),
  users: z.array(z.string()).default([]),
  manufacturers: z.array(z.string()).default([]),
  deviceModels: z.array(z.string()).default([]),
  maintenanceStatus: z.array(z.string()).default([]),
  deviceTags: z.array(z.string()).default([]),
  caseTags: z.array(z.string()).default([]),
  caseTypes: z.array(z.string()).default([]),
  maintenanceTags: z.array(z.string()).default([]),
});

export const defaultGlobalFiltersContext = {
  expanded: false,
  optionsApplied: false,
  toggle: () => {},
  close: () => {},
  resetOptions: () => {},
  options: defaultGlobalFilters,
  setOptions: () => {},
  queryFilters: {
    deployments: undefined,
    users: undefined,
    manufacturers: undefined,
    deviceModels: undefined,
    maintenanceStatus: undefined,
    deviceTags: undefined,
    caseTags: undefined,
    caseTypes: undefined,
    maintenanceTags: undefined,
  },
  queryFilterAddons: {
    deviceTagsNegation: [],
    caseTagsNegation: [],
    caseTypesNegation: [],
    maintenanceTagsNegation: [],
    deviceTagsChildrenDevices: [],
    deviceTagsChildrenCases: [],
    deviceTagsNegationCases: [],
    deviceTagsChildrenMaintenances: [],
    deviceTagsNegationMaintenances: [],
    deviceTagsChildrenMaintenanceStrategies: [],
    deviceTagsNegationMaintenanceStrategies: [],
    deviceTagsChildrenAssembledParts: [],
    deviceTagsNegationAssembledParts: [],
    deviceModelsAssembledParts: [],
  },
  getDynamicQueryFilter: () => undefined,
};
